import {useEffect} from 'react'

import {V2_FIELDS} from '../schema/contactSchema.js'

export const useUserDataPrefill = ({userData, applyPrefill}) => {
  useEffect(() => {
    if (!userData) {
      return
    }

    applyPrefill({
      values: {
        [V2_FIELDS.NAME]: userData.name,
        [V2_FIELDS.EMAIL]: userData.email,
        [V2_FIELDS.PHONE]: userData.phone,
        [V2_FIELDS.ZIP_CODE]: userData.zipCode
      },
      areTermsAccepted: true
    })
  }, [userData, applyPrefill])
}

export default useUserDataPrefill
